<template>
  <div class="ap-figures">
    <div v-for="figure in figures" :key="figure.label">
      <small class="ap-figures__label">{{ figure.label }}</small>
      <span class="ap-figures__value">
        <template v-if="figure.leading"><strong>{{ figure.leading.value }}</strong> <small>{{ figure.leading.unit }}</small>{{ ' ' }}</template>
        <strong>{{ figure.value }}</strong> <small>{{ figure.unit }}</small>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ActivityFigure } from '../../../utils/recordingActivity/recordingActivity';

defineProps<{ figures: ActivityFigure[] }>();
</script>

<style scoped>
.ap-figures {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 2.5rem;
  padding: 12px 20px 4px;
}

.ap-figures__label {
  display: block;
  margin-bottom: 2px;
  color: var(--text-muted, #b2b2b2);
}

.ap-figures__value strong {
  font-size: 1.4rem;
}

.ap-figures__value small {
  color: var(--text-muted, #b2b2b2);
}
</style>
